import config from '../../../../application/config/config';
import { loadData } from "../../../../core/components/core/Util/List/CustomList/loadData";
import CustomList from '../Util/List/CustomList/CustomList';
import CustomListContainer from "../Util/List/CustomList/CustomListContainer";
import { getDefaultEndDate, getDefaultStartDate } from './Utils/getCurrentDate';

function List() {
 const pathFrontEnd = '/core/logs/';
 const listPaths = {
    endpoint: config.endpoints.backend + 'core/logs/getall',
    endpointGetAllUsers: config.endpoints.backend + 'core/users/getAllLoginName',
    endpointGetInstances: config.endpoints.backend + 'core/applicationsinstances/getall'
 }

 const formPaths = {
    urlGoBack: pathFrontEnd + 'list', 
    pathView: pathFrontEnd + 'view',
    endpointGetById: config.endpoints.backend + 'core/logs/getById',
 };

 const values = {
    date_start: getDefaultStartDate(),
    date_end: getDefaultEndDate()
 }

 const filters = {
  validateOnChange: true,
  showGoBackButton: false,
  showSubmitButton: false,
  handleSubmit: loadData,
  fields: [
    {
        name: 'core_application_instance_id',
        type: 'select',
        label: 'Instalação',
        options: [],
        optionsEndpoint: {
            value: 'id',
            label: 'instance_name',
            endpoint: listPaths.endpointGetInstances,
        },
        validations: {
            required: false,
        },        
        columnSize: 12,
    },
    {
        name: 'core_user_id',
        type: 'select',
        label: 'Usuário',
        options: [],
        optionsEndpoint: {
            value: 'id',
            label: 'user_login_name',
            endpoint: listPaths.endpointGetAllUsers,
        },
        validations: {
            required: false,
        },        
        columnSize: 12,
    },
    {
        name: 'log_type',
        type: 'select',
        label: 'Operação',
        options: [
            { value: 'CREATE', label: 'Inclusão'},
            { value: 'DELETE', label: 'Exclusão'},
            { value: 'UPDATE', label: 'Atualização'}
        ],
        validations: {
            required: false,
        },        
        columnSize: 12,
    },
    {
        name: 'date',
        name_start: 'date_start',
        name_end: 'date_end',
        type: 'date_period',
        label: 'Data',
        validations: {
            required: true,
        },        
        columnSize: 3,
    },
    {
        name: 'filtro',
        type: 'submit',
        label: 'Pesquisar',
        columnSize: 1,
    },
    {
        name: 'reset',
        type: 'reset',
        label: 'Limpar',
        columnSize: 2,
    },
  ],
  values: {
    date_start: values.date_start,
    date_end: values.date_end
  }
 }

 let list = {
  type: 'dialog',
  canView: true,
  canAdd: false,
  canEdit: false,
  canDelete: false,
  labelTitle: 'Lista de Logs',
  viewActionColumn: true,
  formFilters: filters,
  columns: [
    {
        name: 'formatted_date',
        label: 'Data',
    },
    {
        name: 'instance_name',
        label: 'Instalação'
    },
    {
        name: 'message',
        label: 'Descrição'
    },
    {
        name: 'formatted_log_type',
        label: 'Operação'
    }
  ],
  buttonsListContainer: [],
  columnsButtons: [],
  ...listPaths,
 };

 const form = {
    containerType: 'dialog',
    validateOnChange: true,
    labelTitleView: 'Visualizar Log',
    fields: [
        {
            name: 'formatted_date',
            type: 'text',
            label: 'Data',
            validations: {
              required: true
            },
            columnSize: 12
          },
          {
            name: 'instance_name',
            type: 'text',
            label: 'Instalação',
            validations: {
                required: true
            },
            columnSize: 12
          },
          {
            name: 'user_name_login',
            type: 'text',
            label: 'Usuário',
            validations: {
                required: true
            },
            columnSize: 12
          },
          {
            name: 'formatted_log_type',
            type: 'text',
            label: 'Operação',
            validations: {
              required: true
            },
            columnSize: 12
          },
          {
            name: 'route',
            type: 'text',
            label: 'Rota',
            validations: {
              required: true
            },
            columnSize: 12
          },
          {
            name: 'message',
            type: 'textarea',
            label: 'Descrição',
            validations: {
              required: true
            },
            columnSize: 12
          },

    ],
    ...formPaths,
 }

 list.form = form;


 return (
     <div>
         <CustomListContainer
             list={list}
             form={form}
             buttons={list.buttonsListContainer}
             labelTitle={list.labelTitle}
             content={<CustomList list={list} />}
         /> 
     </div>
 );
}

export default List;